import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function buildBookingUrl(slug: string): string {
  const rootDomain = process.env.NEXT_PUBLIC_ROOT_DOMAIN || "localhost:3000";
  const appSubdomain = process.env.NEXT_PUBLIC_APP_SUBDOMAIN;
  const isLocalhost = rootDomain.includes("localhost");

  if (isLocalhost) {
    return `http://${rootDomain}/${slug}`;
  }

  if (appSubdomain) {
    return `https://${slug}.${appSubdomain}.${rootDomain}`;
  }

  return `https://${slug}.${rootDomain}`;
}

export function formatMinutesToHourString(minutes: number) {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours ? `${hours}h` : ""} ${mins ? `${mins}m` : ""}`.trim();
}
